import * as type from './type';
export default {

}


// WEBPACK FOOTER //
// ./src/store/letter/mutations.js